import {
  FileText,
  LayoutDashboard,
  MapPin,
  BedDouble,
  Stethoscope,
  Pill,
  Microscope,
  Package,
  Users,
  CalendarClock,
  Receipt,
  UserCog,
  ShieldCheck,
  Workflow,
  Handshake,
  BadgeCheck,
  LifeBuoy,
  Bell,
  CreditCard,
  CalendarCheck,
  Hospital,
} from "lucide-react";

export const sidebarSections = [
  {
    title: "Overview",
    links: [
      { name: "Dashboard", icon: LayoutDashboard, route: "/dashboard" },
      { name: "OPD · Appointments", icon: CalendarCheck, route: "/opd" },
      { name: "IPD · Inpatients", icon: Hospital, route: "/ipd" },
    ],
  },
  {
    title: "Hospital setup",
    links: [
      { name: "Locations", icon: MapPin, route: "/providers/locations" },
      { name: "Wards", icon: BedDouble, route: "/providers/ward" },
      { name: "Services", icon: Stethoscope, route: "/general/services" },
      { name: "Pharmacy", icon: Pill, route: "/general/pharmacy" },
      { name: "Diagnostics", icon: Microscope, route: "/general/diagnostic" },
      { name: "Packages", icon: Package, route: "/general/package" },
    ],
  },
  {
    title: "Clinical",
    links: [
      { name: "Patients", icon: Users, route: "/patients" },
      { name: "Prescriptions", icon: FileText, route: "/prescriptions" },
      { name: "Doctor roster", icon: CalendarClock, route: "/apps/practitioner/roster" },
    ],
  },
  {
    title: "Finance",
    links: [
      { name: "Finance", icon: Receipt, route: "/finance" },
      { name: "Billing", icon: Receipt, route: "/billing" },
      { name: "Subscription", icon: CreditCard, route: "/subscription" },
    ],
  },
  {
    title: "People & access",
    links: [
      { name: "Staff & doctors", icon: UserCog, route: "/iam/users" },
      { name: "Roles", icon: ShieldCheck, route: "/iam/roles" },
    ],
  },
  {
    title: "More",
    links: [
      {
        name: "Workspace",
        icon: Workflow,
        subLink: [
          { name: "Workflows", route: "/workSpace/workflows" },
          { name: "Workforms", route: "/workSpace/workforms" },
          { name: "Workstates", route: "/workSpace/workstates" },
        ],
      },
      { name: "Partner agreements", icon: Handshake, route: "/partners/agreement" },
      { name: "Trust", icon: BadgeCheck, route: "/trust" },
      { name: "Support", icon: LifeBuoy, route: "/support" },
      { name: "Notifications", icon: Bell, route: "/notification" },
    ],
  },
];
